import React from 'react';
import { BgImage } from '../components/Img';
import { IMG } from '../images';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div>
      {/* Hero Section */}
      <section 
        className="hero" 
        style={{
          minHeight: '40vh'
        }}
      >
        <BgImage image={IMG.facade} position="50% 40%" priority />
        <div className="hero-content">
          <h1>Terms & Conditions</h1>
          <p>Rope Access Services – Terms & Conditions</p>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            
            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>1. Definitions</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Agreement</strong> means the agreement between ProClimb Solutions ("Supplier") and the Client for the provision of rope access services, consisting of the Quote and these Terms & Conditions.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Client</strong> means the individual, company or entity accepting the Quote.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Quote</strong> means the written quotation issued by ProClimb Solutions describing the services to be provided.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Services</strong> means the rope access works, including but not limited to:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Rope Access Maintenance</li>
                <li>High Rise Window Cleaning</li>
                <li>Facade Cleaning</li>
                <li>Building Maintenance</li>
                <li>Anchor Installation & Inspection</li>
                <li>Pressure Cleaning</li>
                <li>Waterproofing or repair works</li>
              </ul>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Business Day</strong> means any day excluding weekends and public holidays in New South Wales, Australia.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Force Majeure Event</strong> means any event beyond reasonable control including extreme weather, fire, flood, natural disasters, strikes, pandemics, and government restrictions.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}><strong>Australian Consumer Law (ACL)</strong> refers to Schedule 2 of the Competition and Consumer Act 2010 (Cth).</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>2. Acceptance of Quote</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Acceptance of a Quote may be made by email confirmation, written approval, or digital acceptance. Upon acceptance, the Client agrees to these Terms & Conditions.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>ProClimb Solutions reserves the right to adjust the Quote if a site inspection reveals different conditions, measurements change, or additional safety requirements are identified. Clients will be informed of any variation before proceeding.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>If the Client cancels a confirmed service, ProClimb Solutions reserves the right to charge a cancellation fee of up to 50% of the quoted amount.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>3. Payment Terms</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Unless otherwise agreed in writing:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Payment is due within 14 days of invoice</li>
                <li>ProClimb Solutions may request a 50% deposit before commencement</li>
                <li>The remaining balance is payable upon completion of services</li>
              </ul>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Late payments may incur interest of 10% per annum, calculated daily. The Client agrees to cover any costs associated with debt recovery, including administrative costs, legal fees, and collection agency costs.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>4. Site Access & Client Responsibilities</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>The Client must ensure that:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Safe access to the work site is provided</li>
                <li>Anchor points and safety systems meet Australian Standards</li>
                <li>Other trades working in the area are disclosed prior to works</li>
              </ul>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>If technicians attend site and are unable to perform work due to restricted access, unsafe conditions, or incomplete preparation, a rescheduling fee of up to 40% of the quoted value may apply.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>5. Rope Access Safety & Compliance</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>ProClimb Solutions performs rope access works in accordance with relevant Australian Standards including AS/NZS 4488 – Industrial Rope Access Systems and AS/NZS 1891 – Industrial Fall Arrest Systems.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Anchor points must be certified within the previous 12 months. If anchor points are unsafe or defective, additional certification or rescheduling may be required at the Client's cost.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>6. Window Cleaning & Maintenance Services</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>The Client acknowledges that the Quote does not include removal of permanent water stains, concrete residue, paint splatter, construction debris, or glass defects.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Additional treatments such as chemical removal, polishing, or restoration may incur additional charges.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>7. Working Conditions</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>ProClimb Solutions will take reasonable care while performing services, however the company is not responsible for pre-existing damage, deterioration of building materials, or fragile surfaces including paint, render, roofing edges, membranes, timber, and cladding finishes.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>8. Delays & Weather</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Rope access work is weather dependent. ProClimb Solutions reserves the right to reschedule services due to unsafe conditions including high winds, rain, storms, or lightning. Such delays will not constitute a breach of contract.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>9. Liability</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>To the maximum extent permitted by law, ProClimb Solutions limits its liability to the value of the quoted services. ProClimb Solutions will not be liable for indirect loss, loss of profit, business interruption, or consequential damages.</p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Where Consumer Guarantees apply under Australian Consumer Law, ProClimb Solutions may elect to re-supply the services, or cover the cost of having the services supplied again.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>10. Complaints</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Any complaints regarding services must be submitted in writing within 7 days of completion of the works. ProClimb Solutions will review and respond in a reasonable timeframe.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>11. Governing Law</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>These Terms & Conditions are governed by the laws of New South Wales, Australia. Any legal proceedings shall be subject to the jurisdiction of the courts of New South Wales.</p>
            </div>

            <div style={{ background: 'var(--light-gray)', padding: '2rem', border: '1px solid var(--border-color)', marginTop: '3rem' }}>
              <p style={{ marginBottom: '1rem' }}>Last Updated: January 2025</p>
              <p>For questions about these Terms & Conditions, please contact us at <a href="mailto:info@proclimbsolutions.com.au" style={{ color: 'var(--safety-orange)' }}>info@proclimbsolutions.com.au</a></p>
            </div>

            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <Link to="/contact" className="btn-primary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
